import(/* webpackMode: "eager" */ "/codebuild/output/src3860321604/src/midapos/node_modules/next/dist/client/image-component.js");
